export const ProductionDeclarationMaterialStatusCode = {
  Pending: 'pending',
  Approved: 'approved',
  Rejected: 'rejected',
};

export type ProductionDeclarationMaterialStatusCode =
  (typeof ProductionDeclarationMaterialStatusCode)[keyof typeof ProductionDeclarationMaterialStatusCode];
